export enum ConnectType {
  JOINT_CERT = '1', // 공동인증서
  ID_PW = '2', // 아이디/비밀번호
  DIGITAL_CERT = '9', // 디지털인증서
  FIN_CERT_PIN = 'B', // 금융인증서(간편비밀번호)
  FIN_CERT_BIO = 'C', // 금융인증서(지문/안면인식)
  FIN_TECH_TOSS = 'D', // 핀테크인증서(토스)
  MOTP = 'G', // MOTP
}

// 로그인 타입 (value : native storage 로그인 타입 저장값)
export enum LoginType {
  JOINT_CERT = 'cert',
  JOINT_CERT_UBIKEY = 'cert.ubikey',
  // JOINT_CERT_USIM = 'cert.usim',     // (ASIS 미사용)
  ID_PW = 'id',
  DIGITAL_CERT_PIN = 'pin',
  DIGITAL_CERT_FINGER = 'bio',
  DIGITAL_CERT_FACEID = 'faceId',
  FIN_CERT_PIN = 'FinCert_PIN',
  FIN_CERT_FINGER = 'FinCert_BIO_Finger',
  FIN_CERT_FACEID = 'FinCert_BIO_FaceId',
  FIN_TECH_TOSS = 'PinTech_toss',
  MOTP = 'motp',
}

export enum NativeLoginStatus {
  LOGOUT = '0',
  ID_PW = '1',
  JOINT_CERT = '2',
  JOINT_CERT_UBIKEY = '3',
  // JOINT_CERT_USIM = '4', // (ASIS 미사용)
  // BANK_SIGN = '5', // (ASIS 미사용)
  DIGITAL_CERT = '6',
  FIN_CERT = '7',
  FIN_TECH_TOSS = '8',
  MOBILE_OTP = '9', // TOBE 추가
}
